//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import workOrder from "../../../../store/modules/workOrder";
import { WorkOrderSource } from "../../../../store/entities/workOrder"
import PageDutyfeedbackPopup from "./page-dutyfeedback-popup";
import PageFeedbackPopup from "./page-feedback-popup";
import PageTransferOrderView from './page-transferOrder-view';
import PageCancelOrderPopup from './page-cancelOrder-popup.vue';

export default {
    name: "page-action-button",
    components: { PageFeedbackPopup, PageDutyfeedbackPopup, PageTransferOrderView, PageCancelOrderPopup },
    data() {
        return {
            // currentUser: {},
            isNeedReceiving: false,
            WorkOrderSource,
            dutyFeedbackPopup: false,
            feedbackPopup: false,
            transferOrderPopup: false,
            cancelOrderPopup: false,
        }
    },
    props: {
        currentUser: {
            type: Object,
            required: true
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        },
        permission() {
            return this.$store.state.workOrder.memberPermission;
        },

    },
    methods: {

        acceptPopup() {
            this.$emit('acceptPopup')
        },

        dispachPopup(data) {
            this.$emit('dispachPopup', data);
        },
        showPaiGongPopup(data) {
            this.$emit('showPaiGongPopup', data);
        },
        showEditResult(data) {
            this.$emit('showEditResult', data);
        },
        showtransferOrderPopup() {
            this.$emit('showtransferOrderPopup')
        },
        showWeiXiuPopup() {
            this.$emit('showWeiXiuPopup')
        },
        // showReceiptPopup() {
        //   this.$emit('showReceiptPopup')
        // },
        showChargebackPopup() {
            this.$emit('showChargebackPopup')
        },

        onShowReturnVisitPopup(data) {
            this.$emit('onShowReturnVisitPopup', data)
        },

        onShowChaoSongPopup(data) {
            this.$emit('onShowChaoSongPopup', data);
        },

        onJieDan(data) {
            this.$emit('onJieDan', data);
        },

        onShowShangMenPopup(data) {
            this.$emit('onShowShangMenPopup', data);
        },

        onShowPaiDanReturnOrderPopup() {
            this.$emit('onShowPaiDanReturnOrderPopup');
        },

        onShowSelectCompanyPopup() {
            this.$emit('onShowSelectCompanyPopup')
        },

        onShowSplitView() {
            this.$emit('onShowSplitView')
        },
        handleRefreshLogs() {
            this.$emit('handleRefreshLogs')
        }
    },
    created() {
        // this.getCurrentUserByMember()

    },
    watch: {}
}
